module.exports = __webpack_public_path__ + "static/media/BigArrow.d15d35f8.svg";